<template>
  <div>
    <Form
      ref="addModel"
      :model="addModel"
      :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="设备名称" prop="clientName">
        <Input v-model="addModel.clientName"></Input>
      </FormItem>
      <FormItem label="设备类型" prop="clientType">
        <Input v-model="addModel.clientType"></Input>
      </FormItem>
      <FormItem label="所属机构" prop="organName">
        <Button type="primary" @click="treeModel = true">选择机构</Button>
        <span class="ml-5">{{ addModel.organName }}</span>
      </FormItem>
      <FormItem label="外网IP">
        <Input v-model="addModel.publicIp"></Input>
      </FormItem>
      <FormItem label="内网IP">
        <Input v-model="addModel.privateIp"></Input>
      </FormItem>
      <FormItem label="服务器用户名">
        <Input v-model="addModel.remoteUserName"></Input>
      </FormItem>
      <FormItem label="服务器密码">
        <Input v-model="addModel.remotePassword"></Input>
      </FormItem>
      <FormItem label="数据库用户名">
        <Input v-model="addModel.dataBaseUserName"></Input>
      </FormItem>
      <FormItem label="数据库密码">
        <Input v-model="addModel.dataBasePassword"></Input>
      </FormItem>

      <FormItem label="描述信息">
        <Input
          v-model="addModel.clientDescription"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
        ></Input>
      </FormItem>
    </Form>
    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('addModel')"
        >确 定</Button
      >
    </div>

    <Modal v-model="treeModel" title="选择机构">
      <organTree @selectTreeData="selectTreeData"></organTree>
    </Modal>
  </div>
</template>
<script>
import organTree from "../../basedata/organ/organTree.vue";
export default {
  components: { organTree },
  data: function () {
    return {
      treeModel: false,
      organParentName: "",
      addModel: {
        clientName: "",
        clientType: "",
        clientDescription: "",
        organID: "",
        organName: "",
        publicIp: "",
        privateIp: "",
        remoteUserName: "",
        remotePassword: "",
        dataBaseUserName: "",
        dataBasePassword: "",
      },
      SecretTypeSelect: [],
      ruleValidate: {
        clientName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        clientType: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        organName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    this.SecretTypeSelect = this.$common.getJsonData("clientType");
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("client/create", this.addModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("添加成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },

    resetData() {
      for (let key in this.addModel) {
        this.addModel[key] = "";
      }
      this.$refs["addModel"].resetFields();
    },
    selectTreeData: function (data) {
      this.addModel.organID = data[0].organID;
      this.addModel.organName = data[0].title;
    },
  },
};
</script>
<style scoped>
</style>